var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footernav-en"},[_c('div',{staticClass:"container"},[_vm._v(" Copyright (c) "+_vm._s(_vm.copyrightYear)+" Guangdong Tianan New Material Co., LTD ")])])}
var staticRenderFns = []

export { render, staticRenderFns }